// 小于 1k 正常显示，按千分位向上取整加k且保留一位小数（加K+）
export function formatSaleCount(count: number): number | string | undefined {
  if (count < 1000) {
    return count;
  }

  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}RB+`;
  }
}
